import { rolePermissions } from '@ceres/domain';

export default rolePermissions;
